












































































































































































import Vue from 'vue';
import {
  Component, Watch, Prop,
} from 'vue-property-decorator';
import { AnswerMap } from '@/api/AnswerMap';

@Component
export default class MacroPreviewOptions extends Vue {
    @Prop()
    initialAnswers!: AnswerMap;

    answers: AnswerMap = {
      documentType: 'MDG',
      materialType: 'ICH',
      institutionType: 'BANK',
      brandingType: 'KASASA',
      productTypes: [],
      saverLink: 'NONE',
      saverAndCash: 'EQUAL',
      saverAndCashBack: 'EQUAL',
      saverAndTunes: 'EQUAL',
      incentive: 'FALSE',
      kasasaProtect: 'MENTIONED',
      interestCredited: 'LAST_DAY_OF_CURRENT_STATEMENT_CYCLE',
      rewardCredited: 'LAST_DAY_OF_CURRENT_STATEMENT_CYCLE',
      balanceComputation: 'DAILY_BALANCE',
      nonQualifyingBalanceComputation: 'DAILY_BALANCE',
      interestAccrued: 'THE_DAY_YOU_DEPOSIT_NON_CASH_ITEMS',
      interestCompounding: 'DAILY',
      atmFeeReimbursementMethodology: 'CALCULATION',
      operationalTimeframes: 'DAYS',
      monthlyQualificationCycle: 'ONE_DAY_ASYNCHRONOUS_WITHOUT_WEEKEND_PROCESSING',
      addressGamers: 'NO',
      iop: 'NO',
      comparisonClaims: false,
      qualificationsShown: false,
      ratesFeatured: false,
      rewardsMentioned: false,
      atmMentioned: false,
      loanRatesShown: false,
      riskTolerance: 'HIGH',
    }

    tab: number = 0;

    readonly documentTypes:any[] = [{ text: 'MDG', value: 'MDG' }, { text: 'ADG', value: 'ADG' }, { text: 'Cycles', value: 'CYCLES' }]

    readonly materialTypes:any[] = [{ text: 'In Consumer Hands', value: 'ICH' }, { text: 'In Consumer Hands - Electronic', value: 'ICHE' }, { text: 'In-Branch Materials', value: 'IBM' }, { text: 'Out Of Home', value: 'OOH' }, { text: 'Television, Radio, Telephone', value: 'TVRT' }]

    readonly saverLinkTypes:any[] = [{ text: 'Saver Featured, Linked Accounts Mentioned', value: 'MENTIONED' }, { text: 'Saver and Linked Accounts Featured Equally', value: 'EQUAL' }, { text: 'Linked Accounts Featured, Saver Mentioned', value: 'FEATURED' }, { text: 'None', value: 'NONE' }]

    readonly saverAndCashTypes:any[] = [{ text: 'Cash Featured / Saver Mentioned', value: 'CASH_FEATURE_SAVER_MENTION' }, { text: 'Saver Featured / Cash Mentioned', value: 'SAVER_FEATURE_CASH_MENTION' }, { text: 'Both Featured Equally', value: 'EQUAL' }]

    readonly saverAndCashBackTypes:any[] = [{ text: 'CashBack Featured / Saver Mentioned', value: 'CASH_BACK_FEATURE_SAVER_MENTION' }, { text: 'Saver Featured / CashBack Mentioned', value: 'SAVER_FEATURE_CASH_BACK_MENTION' }, { text: 'Both Featured Equally', value: 'EQUAL' }]

    readonly saverAndTunesTypes:any[] = [{ text: 'Tunes Featured / Saver Mentioned', value: 'TUNES_FEATURE_SAVER_MENTION' }, { text: 'Saver Featured / Tunes Mentioned', value: 'SAVER_FEATURE_TUNES_MENTION' }, { text: 'Both Featured Equally', value: 'EQUAL' }]

    readonly incentiveTypes:any[] = [{ text: 'None', value: 'FALSE' }, { text: 'Cash Incentive', value: 'CASH_INCENTIVE' }, { text: 'Cash Incentive (Media Required)', value: 'CASH_INCENTIVE_MEDIA_REQUIRED' }, { text: 'Non-Cash Incentive', value: 'NON_CASH_INCENTIVE' }]

    readonly kasasaProtectTypes:any[] = [{ text: 'Featured', value: 'FEATURED' }, { text: 'Mentioned', value: 'MENTIONED' }]

    readonly riskToleranceTypes:any[] = [{ text: 'Minimum', value: 'MINIMUM' }, { text: 'Low', value: 'LOW' }, { text: 'Medium', value: 'MEDIUM' }, { text: 'High', value: 'HIGH' }]

    readonly institutionTypes:any[] = [{ text: 'Bank', value: 'BANK' }, { text: 'Credit Union', value: 'CREDIT_UNION' }]

    readonly brandingTypes:any[] = [{ text: 'Kasasa', value: 'KASASA' }, { text: 'White Label', value: 'WHITE_LABEL' }]

    readonly interestCompoundingTypes:any[] = [{ text: 'Daily Balance', value: 'DAILY' }, { text: 'Monthly', value: 'MONTHLY' }]

    readonly balanceComputationTypes:any[] = [{ text: 'Daily Balance', value: 'DAILY_BALANCE' }, { text: 'Average Daily Balance', value: 'AVERAGE_DAILY_BALANCE' }]

    readonly interestCreditedTypes:any[] = [{ text: 'Last Day of Current Cycle', value: 'LAST_DAY_OF_CURRENT_STATEMENT_CYCLE' }, { text: 'First Processing Day of Following Cycle', value: 'FIRST_PROCESSING_DAY_OF_FOLLOWING_STATEMENT_CYCLE' }]

    readonly interestAccruedTypes:any[] = [{ text: 'Day Of Deposit', value: 'THE_DAY_YOU_DEPOSIT_NON_CASH_ITEMS' }, { text: 'Business Day Of Deposit', value: 'THE_BUSINESS_DAY_YOU_DEPOSIT_NON_CASH_ITEMS' }, { text: 'Banking Day Of Deposit', value: 'THE_BANKING_DAY_YOU_DEPOSIT_NON_CASH_ITEMS' }]

    readonly monthlyQualificationCycleTypes:any[] = [{ text: 'One Day Asynchronous w/o Weekend', value: 'ONE_DAY_ASYNCHRONOUS_WITHOUT_WEEKEND_PROCESSING' }, { text: 'One Day Asynchronous w/ Weekend (7-day)', value: 'ONE_DAY_ASYNCHRONOUS_WITH_WEEKEND_PROCESSING_7_DAYS' }, { text: 'One Day Asynchronous w/ Weekend (6-day)', value: 'ONE_DAY_ASYNCHRONOUS_WITH_WEEKEND_PROCESSING_6_DAYS' },
      { text: 'One Month Asynchronous', value: 'ONE_MONTH_ASYNCHRONOUS_PROCESSING' }, { text: 'Synchronous', value: 'SYNCHRONOUS_PROCESSING' }]

    readonly atmFeeReimbursementMethodologyTypes:any[] = [{ text: 'Calculation', value: 'CALCULATION' }, { text: 'Direct Scan', value: 'DIRECT_SCAN' }, { text: 'Flat Rate', value: 'FLAT_RATE' },
      { text: 'Not Offered', value: 'FALSE' }]

    readonly rewardCreditedTypes:any[] = [{ text: 'Last Day of Current Cycle', value: 'LAST_DAY_OF_CURRENT_STATEMENT_CYCLE' }, { text: 'First Processing Day of Following Cycle', value: 'FIRST_PROCESSING_DAY_OF_FOLLOWING_STATEMENT_CYCLE' }]


    readonly allProducts: any[] = [
      { value: 'KASASA_CASH', text: 'Kasasa Cash / Interest Reward' },
      { value: 'KASASA_CASH_BACK', text: 'Kasasa Cash Back / Cash Back Reward' },
      { value: 'KASASA_CASH_BACK_MULTI_LEVEL', text: 'Kasasa Cash Back - Multi-Level' },
      { value: 'KASASA_SAVER', text: 'Kasasa Saver / Automatic Savings Reward' },
      { value: 'KASASA_PLAY', text: 'Kasasa Play' },
      { value: 'KASASA_EATS', text: 'Kasasa Eats' },
      { value: 'KASASA_TUNES', text: 'Kasasa Tunes' },
      { value: 'KASASA_GIVING', text: 'Kasasa Giving' },
      { value: 'KASASA_PROTECT', text: 'Kasasa Protect' },
      { value: 'KASASA_LOANS', text: 'Kasasa Loans' },
      { value: 'SHARE_KASASA', text: 'Share Kasasa' },
      { value: 'IN_CONTROL_REWARDS', text: 'In Control (Rewards)' },
      { value: 'IN_CONTROL_REDUCTION_METHOD', text: 'In Control (Burn Down Method)' },
      { value: 'IN_CONTROL_ELIMINATION_METHOD', text: 'In Control (Qualification Method)' },
      { value: 'IN_CONTROL_CLASSIC', text: 'In Control Multilevel' },
    ];

    fiId: string = '99999';

    showSaverCash: boolean = false;

    showSaverCashBack: boolean = false;

    showSaverLink: boolean = false;

    showSaverTunes: boolean = false;

    showProtect: boolean = false;

    showLoans: boolean = false;

    showGenericRewards: boolean = false;

    mounted() {
      if (this.initialAnswers) {
        Object.assign(this.answers, this.initialAnswers);
      }

      this.onAnswerChange();
      this.onFiIdChange();
    }

    @Watch('answers', { deep: true })
    onAnswerChange() {
      const showTunesIncentive:boolean = (this.answers.productTypes as string[]).includes('KASASA_TUNES');

      if (showTunesIncentive && this.incentiveTypes.length === 4) {
        this.incentiveTypes.push({ text: 'Sign-Up Bonus For Tunes', value: 'CASH_INCENTIVE_KASASA_TUNES' });
      } else if (!showTunesIncentive && this.incentiveTypes.length === 5) {
        this.incentiveTypes.splice(4);
      }

      this.showSaverCash = (this.answers.productTypes as string[]).includes('KASASA_SAVER') && (this.answers.productTypes as string[]).includes('KASASA_CASH') && !(this.answers.productTypes as string[]).includes('KASASA_CASH_BACK') && !(this.answers.productTypes as string[]).includes('KASASA_TUNES');
      this.showSaverCashBack = (this.answers.productTypes as string[]).includes('KASASA_SAVER') && (this.answers.productTypes as string[]).includes('KASASA_CASH_BACK') && !(this.answers.productTypes as string[]).includes('KASASA_CASH') && !(this.answers.productTypes as string[]).includes('KASASA_TUNES');
      this.showSaverTunes = (this.answers.productTypes as string[]).includes('KASASA_SAVER') && (this.answers.productTypes as string[]).includes('KASASA_TUNES') && !(this.answers.productTypes as string[]).includes('KASASA_CASH') && !(this.answers.productTypes as string[]).includes('KASASA_CASH_BACK');
      this.showSaverLink = (this.answers.productTypes as string[]).includes('KASASA_SAVER') && !this.showSaverCash && !this.showSaverCashBack && !this.showSaverTunes;
      this.showProtect = (this.answers.productTypes as string[]).includes('KASASA_PROTECT');
      this.showLoans = (this.answers.productTypes as string[]).includes('KASASA_LOANS');
      this.showGenericRewards = (this.answers.productTypes as string[]).length === 0;

      const cleanAnswers: AnswerMap = this.cleanAnswers();
      this.$emit('newAnswers', cleanAnswers);
    }

    // Internal answers object contains defaults for all possible values so that they can be watched by Vue,
    // but some may be mutually exclusive and should be stripped before use.
    cleanAnswers() : AnswerMap {
      const cleanAnswers: AnswerMap = Object.assign({}, this.answers);

      if (this.answers.documentType === 'MDG') {
        if (!this.showSaverLink) {
          delete cleanAnswers.saverLink;
        }
        if (!this.showSaverCash) {
          delete cleanAnswers.saverAndCash;
        }
        if (!this.showSaverCashBack) {
          delete cleanAnswers.saverAndCashBack;
        }
        if (!this.showSaverTunes) {
          delete this.answers.saverAndTunes;
        }
        if (this.showProtect) {
          delete cleanAnswers.kasasaProtect;
        }
        if (!this.showLoans) {
          delete cleanAnswers.loanRatesShown;
        }
        if (!this.showGenericRewards) {
          delete cleanAnswers.rewardsMentioned;
        }
      } else if (this.answers.documentType === 'ADG') {
        delete cleanAnswers.saverLink;
        delete cleanAnswers.saverAndCash;
        delete cleanAnswers.saverAndCashBack;
        delete cleanAnswers.saverAndTunes;
        delete cleanAnswers.materialType;
        delete cleanAnswers.comparisonClaims;
        delete cleanAnswers.qualificationsShown;
        delete cleanAnswers.ratesFeatured;
        delete cleanAnswers.rewardsMentioned;
        delete cleanAnswers.atmMentioned;
        delete cleanAnswers.loanRatesShown;
        delete cleanAnswers.riskTolerance;
      }

      return cleanAnswers;
    }

    @Watch('fiId')
    onFiIdChange() {
      this.$emit('newFiId', this.fiId);
    }
}
